import { render, staticRenderFns } from "./ImgItem.vue?vue&type=template&id=4b1f0ebd&scoped=true"
import script from "./ImgItem.vue?vue&type=script&lang=js"
export * from "./ImgItem.vue?vue&type=script&lang=js"
import style0 from "./ImgItem.vue?vue&type=style&index=0&id=4b1f0ebd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f0ebd",
  null
  
)

export default component.exports